import { init as sentryCapacitorInit } from '@sentry/capacitor';
import { browserTracingIntegration, replayIntegration, init as sentryVueInit } from '@sentry/vue';

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  const { public: { sentry } } = useRuntimeConfig();
  
  if (!sentry.dsn) {
    return;
  }

  sentryCapacitorInit({
    app: nuxtApp.vueApp,
    dsn: process.env.SENTRY_ENVIRONMENT ? process.env.SENTRY_ENVIRONMENT : sentry.dsn,
    environment: sentry.environment,
    integrations: [
      browserTracingIntegration({ router }), 
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      })
    ],

    tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE ? Number(process.env.SENTRY_TRACES_SAMPLE_RATE) : 0.2, // Performance monitoring, represents the percentage chance that any given transaction will be sent to Sentry.
    replaysSessionSampleRate: process.env.SENTRY_REPLAY_SAMPLE_RATE ? Number(process.env.SENTRY_REPLAY_SAMPLE_RATE) : 0,
    replaysOnErrorSampleRate: process.env.SENTRY_ERROR_REPLAY_SAMPLE ? Number(process.env.SENTRY_ERROR_REPLAY_SAMPLE) : 0
  }, sentryVueInit);
});